import { useState } from "react"

import {
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    Collapse,
} from "reactstrap"

import classnames from "classnames"

import ChevronIcon from "./icons/ChevronIcon"

const Panel = ({ title, centerTitle=false, titleSize="h5", collapsable=false, initialCollapseState=false, customCollapsedState, customCollapseToggler, scrollBody=false, minHeight=null, maxHeight=null, children})  => {
    const [collapsed, setCollapsed] = useState(initialCollapseState)
    const toggleCollapsed = () => setCollapsed(!collapsed)
    const noop = () => {}

    const getClickHandler = () => {
        if(!collapsable) {
            return noop
        } else if (undefined !== customCollapseToggler) {
            return () => customCollapseToggler()
        } else {
            return toggleCollapsed
        }
    }

    const getCollapsedValue = () => {
        let retVal = collapsed
        if (undefined !== customCollapsedState) {
            retVal = customCollapsedState
        }
        return retVal
    }

    const wrapWithCollapse = (contents) => {
        if (!collapsable) {
            return (contents)
        } else {
            return (
                <Collapse
                    isOpen={!getCollapsedValue()}
                    style={{
                        height: "fit-content",
                        maxHeight: 'calc(100% - 31px)',
                        width: "100%",
                        overflowY: "scroll"
                    }}
                >
                    {contents}
                </Collapse>
            )
        }
    }

    return (
        <Card
            style={{
                minHeight: !!minHeight ? minHeight : "fit-content",
                height: "fit-content",
                maxHeight: !!maxHeight ? maxHeight : "fit-content"
            }}
        >
            <CardHeader
                style={{
                    textAlign: centerTitle ? "center" : "left",
                    backgroundColor: "white",
                    border: 0,
                    padding: 0,
                    paddingLeft: "5px",
                    borderBottom: "0",
                    // marginTop: "5px"
                }}
                onClick={getClickHandler()}
            >
                <CardTitle
                    className={titleSize}
                    style={{
                        fontSize: "15.8px",
                        fontWeight: "bold",
                        marginBottom: "2px"
                    }}
                >
                    {title} {collapsable && <ChevronIcon expand={!getCollapsedValue()} />}
                </CardTitle>
            </CardHeader>
            {wrapWithCollapse(
                <CardBody
                    style={{
                        height: collapsable ? "100%" : 'calc(100% - 31px)',
                        // overflowY: scrollBody ? "scroll" : "hidden",
                        paddingLeft: 0,
                        paddingRight: 0,
                    }}
                >
                    {children}
                </CardBody>
            )}
        </Card>
    )
}

export default Panel